import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import { useAuth } from '../../../../modules/auth'
import CCPStatusButton from './CCPStatusButton'

interface AppointmentReminderPopupProps {
  show: boolean
  onHide: () => void
  appointmentId?: number
  clientName?: string
  hasSessionStarted: boolean
  requesterName?: string
  dateTime?: string
  type?: string
  communicationTypeIdentification?: string
}

const nonCcpCommunicationTypes = new Set(['ON_SITE', 'THIRD_PART_PLATFORM'])

const AppointmentReminderPopup: React.FC<AppointmentReminderPopupProps> = ({
  show,
  onHide,
  appointmentId,
  clientName,
  requesterName,
  hasSessionStarted,
  dateTime,
  type,
  communicationTypeIdentification
}) => {
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  const isCcpAppointment = !nonCcpCommunicationTypes.has(communicationTypeIdentification ?? '')

  const handleGoToAppointment = () => {
    onHide()
    if (appointmentId) {
      navigate(`/appointmentViewer/${appointmentId}`)
    }
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby='five-min-appointment-reminder-modal'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id='five-min-appointment-reminder-modal'>
          <i className='bi bi-alarm me-2 text-warning'></i>
          You have a scheduled appointment in 5 mins
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p><strong>Client Name:</strong> {clientName}</p>
        <p><strong>Requester Name:</strong> {requesterName}</p>
        <p><strong>Date and Time:</strong> {dateTime ? moment(dateTime).format('MMMM D, YYYY, hh:mm A') : 'N/A'}</p>
        <p><strong>Type:</strong> {type}</p>
        <p>{isCcpAppointment ? 'Please make yourself available on Connect Call Panel and start the session.' : 'Please review the appointment details before the scheduled start time.'}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>Dismiss</Button>
        <Button variant='primary' onClick={handleGoToAppointment}>{isCcpAppointment ? 'Visit Call Panel' : 'View Appointment'}</Button>
        {isCcpAppointment && currentUser?.result?.userType === 'INTERPRETER' && appointmentId && (
          <CCPStatusButton 
            text='Start Session'
            appointmentId={appointmentId}
            hasSessionStarted = {hasSessionStarted}
            appointmentStartTime={dateTime}
            className='btn btn-success'
          />
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default AppointmentReminderPopup
